import React from 'react';
import { Table } from 'rsuite';
import { CompactCell, CompactHeaderCell } from 'Components/Common/Table/CustomCells';
import { EsatusStack } from '../Detail/EstatusStack';
import { ActionCell } from 'Components/Common/Table/CustomMenu';
import { NumericFormat } from 'react-number-format';

const { Column, ColumnGroup } = Table;

export const CustomTable = (props) => {
  const { data, loading, onSelectAction } = props;

  return (
    <Table
      headerHeight={80}
      rowHeight={35}
      data={data}
      loading={loading}
      bordered
      autoHeight
      cellBordered
      // affixHeader
      // affixHorizontalScrollbar
    >
      {/* <Column width={80} align="center" fixed>
        <CompactHeaderCell>Versión</CompactHeaderCell>
        <CompactCell dataKey="version">{(rowData) => `${rowData.dte.identificacion.version}`}</CompactCell>
      </Column> */}
      <ColumnGroup align="center" header="Identificacion">
        <Column width={250} fixed resizable fullText>
          <CompactHeaderCell>Numero de control</CompactHeaderCell>
          <CompactCell dataKey="numControl">{(rowData) => `${rowData.dte.identificacion.numeroControl}`}</CompactCell>
        </Column>
        <Column width={150}>
          <CompactHeaderCell>Fecha y hora de emisión</CompactHeaderCell>
          <CompactCell dataKey="fecEmi">
            {(rowData) => `${rowData.dte.identificacion.fecEmi} ${rowData.dte.identificacion.horEmi}`}
          </CompactCell>
        </Column>
      </ColumnGroup>

      <ColumnGroup align="center" header="Emisor">
        <Column width={125} align="center" colSpan={2}>
          <CompactHeaderCell>NIT</CompactHeaderCell>
          <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.emisor.nit}`}</CompactCell>
        </Column>
        <Column width={80} align="center" colSpan={2}>
          <CompactHeaderCell>NRC</CompactHeaderCell>
          <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.emisor.nrc}`}</CompactCell>
        </Column>
        <Column width={200} align="left" resizable fullText>
          <CompactHeaderCell>Nombre</CompactHeaderCell>
          <CompactCell dataKey="nombree">{(rowData) => `${rowData.dte.emisor.nombre}`}</CompactCell>
        </Column>
      </ColumnGroup>

      <ColumnGroup align="center" header="Receptor">
        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>NIT</CompactHeaderCell>
          <CompactCell dataKey="nit">{(rowData) => `${rowData.dte.receptor.nit ?? '-'}`}</CompactCell>
        </Column>

        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>NRC</CompactHeaderCell>
          <CompactCell dataKey="nrc">{(rowData) => `${rowData.dte.receptor.nrc ?? '-'}`}</CompactCell>
        </Column>

        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>Numero documento</CompactHeaderCell>
          <CompactCell dataKey="numDocumento">{(rowData) => `${rowData.dte.receptor.numDocumento ?? '-'}`}</CompactCell>
        </Column>

        <Column width={280} align="right" resizable>
          <CompactHeaderCell>Nombre</CompactHeaderCell>
          <CompactCell dataKey="nombrer">{(rowData) => `${rowData.dte.receptor.nombre}`}</CompactCell>
        </Column>
        <Column width={280} align="right" resizable>
          <CompactHeaderCell>Correo</CompactHeaderCell>
          <CompactCell dataKey="correor">{(rowData) => `${rowData.dte.receptor.correo ?? '-'}`}</CompactCell>
        </Column>
        {/* <Column width={110} align="center">
          <CompactHeaderCell>Pais</CompactHeaderCell>
          <CompactCell dataKey="paisr">{(rowData) => `${rowData.dte.receptor.nombrePais}`}</CompactCell>
        </Column> */}
      </ColumnGroup>

      <Column width={330} align="center" resizable fullText>
        <CompactHeaderCell>Codigo de generación</CompactHeaderCell>
        <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.identificacion.codigoGeneracion}`}</CompactCell>
      </Column>

      <ColumnGroup align="center" header="Resumen">
        <Column width={130} align="right" colSpan={2}>
          <CompactHeaderCell>Total (USD)</CompactHeaderCell>
          <CompactCell dataKey="selloRecibido">
            {(rowData) => {   
              if (!rowData.dte.resumen) return '-'
              return <NumericFormat
                value={
                  rowData.dte.resumen.totalPagar
                    ? rowData.dte.resumen.totalPagar
                    : rowData.dte.resumen.montoTotalOperacion
                    ? rowData.dte.resumen.montoTotalOperacion
                    : 0
                }
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
              />
            }}
          </CompactCell>
        </Column>
      </ColumnGroup>

      <Column width={370} align="center" colSpan={2}>
        <CompactHeaderCell>Sello de recibido</CompactHeaderCell>
        <CompactCell dataKey="selloRecibido">
          {(rowData) => (rowData.recepcion ? `${rowData.recepcion.selloRecibido ?? '-'}` : 'Sin sello')}
        </CompactCell>
      </Column>
      <Column width={320} align="left">
        <CompactHeaderCell>Estatus</CompactHeaderCell>
        <CompactCell align="left" dataKey="version">
          {(rowData) => (            
            <EsatusStack estatus={rowData.estatus} validationResult={rowData.validationResult} otherValidationsResult={rowData.otherValidationsResult}/>            
          )}
        </CompactCell>
      </Column>
      <Column width={80} fixed="right" align="center">
        <CompactHeaderCell>Acciones</CompactHeaderCell>
        <ActionCell dataKey="id" onSelect={onSelectAction} />
      </Column>
    </Table>
  );
};
